{
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.benefits.admin-key": [
    {
      "children": [
        {
          "type": 0,
          "value": "Admin key"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": Access restricted content so you can fix issues"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.benefits.advanced-insights": [
    {
      "children": [
        {
          "type": 0,
          "value": "Advanced insights"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": Audit and track all admin activity"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.benefits.support": [
    {
      "children": [
        {
          "type": 0,
          "value": "24/7 support"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": Dedicated support team for critical issues"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.description": [
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " wants to try the 'Mission Control' feature on the Premium plan. This will give them a dashboard to easily see activity across spaces."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.no-name.description": [
    {
      "type": 0,
      "value": "Someone on your team has requested to try the 'Mission Control' feature on the Confluence Premium plan. This will give them a dashboard to easily see activity across spaces."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.no-name.subject": [
    {
      "type": 0,
      "value": "Approval required: Someone in your team wants to try 'Mission Control'"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.no-name.title": [
    {
      "type": 0,
      "value": "Help your team do more and worry less"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.subject": [
    {
      "type": 0,
      "value": "Approval required: "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " wants to try 'Mission Control'"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.title": [
    {
      "type": 0,
      "value": "Help "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " stay across team activity"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-features-title": [
    {
      "type": 0,
      "value": "You also get more admin features"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.description": [
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " wants to try advanced page elements on the Premium plan. This will give your team the tools to create richer content."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.no-name.description": [
    {
      "type": 0,
      "value": "Someone on your team wants to try advanced page elements on the Premium plan. This will give your team the tools to create richer content."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.no-name.subject": [
    {
      "type": 0,
      "value": "Approval required: Someone in your team wants to try advanced page elements"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.no-name.title": [
    {
      "type": 0,
      "value": "Help your team create engaging content"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.subject": [
    {
      "type": 0,
      "value": "Approval required: "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " wants to try advanced page elements"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.title": [
    {
      "type": 0,
      "value": "Help "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " create engaging content"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.description": [
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " wants to try the advanced permissions features on the Premium plan. This will let them easily troubleshoot access issues and copy settings to new spaces."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.no-name.description": [
    {
      "type": 0,
      "value": "Someone on your team wants to try the advanced permissions features on the Premium plan. This will let them easily troubleshoot access issues and copy settings to new spaces."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.no-name.subject": [
    {
      "type": 0,
      "value": "Approval required: Someone in your team wants to try advanced permissions features"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.no-name.title": [
    {
      "type": 0,
      "value": "Help your team manage access better"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.subject": [
    {
      "type": 0,
      "value": "Approval required: "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " wants to try advanced permissions features"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.title": [
    {
      "type": 0,
      "value": "Help "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " manage access better"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.description": [
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " wants to try the 'Company Hub' feature on the Premium plan. This will let them create a central place for updates and key resources."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.no-name.description": [
    {
      "type": 0,
      "value": "Someone on your team wants to try the ‘Company Hub’ feature on the Premium plan. This will let them create a central place for updates and key resources."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.no-name.subject": [
    {
      "type": 0,
      "value": "Approval required: Someone in your team wants to try 'Company Hub'"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.no-name.title": [
    {
      "type": 0,
      "value": "Give your team one place to share updates"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.subject": [
    {
      "type": 0,
      "value": "Approval required: "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " wants to try 'Company Hub'"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.title": [
    {
      "type": 0,
      "value": "Give "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " one place to share updates"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.description": [
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " wants to try the 'Content manager' feature on the Premium plan. This will make it easy for them to bulk manage content across spaces."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.no-name.description": [
    {
      "type": 0,
      "value": "Someone on your team wants to try the ‘Content Manager’ feature on the Premium plan. This will make it easy for them to bulk manage content across spaces."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.no-name.subject": [
    {
      "type": 0,
      "value": "Approval required: Someone in your team wants to try 'Content manager'"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.no-name.title": [
    {
      "type": 0,
      "value": "Help your team keep spaces organised"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.subject": [
    {
      "type": 0,
      "value": "Approval required: "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " wants to try 'Content manager'"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.title": [
    {
      "type": 0,
      "value": "Help "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " keep spaces organised"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.body-description": [
    {
      "children": [
        {
          "type": 0,
          "value": "Let "
        },
        {
          "type": 1,
          "value": "firstName"
        },
        {
          "type": 0,
          "value": " try on a free, "
        },
        {
          "type": 1,
          "value": "trialLengthDays"
        },
        {
          "type": 0,
          "value": "-day trial."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "Cancel anytime. We'll remind you "
    },
    {
      "type": 1,
      "value": "reminderDays"
    },
    {
      "type": 0,
      "value": " days before your trial ends."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.description": [
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " has requested to try features on the Confluence Premium plan."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.no-name.body-description": [
    {
      "children": [
        {
          "type": 0,
          "value": "Let your team member try on a free, "
        },
        {
          "type": 1,
          "value": "trialLengthDays"
        },
        {
          "type": 0,
          "value": "-day trial."
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "Cancel anytime. We'll remind you "
    },
    {
      "type": 1,
      "value": "reminderDays"
    },
    {
      "type": 0,
      "value": " days before your trial ends."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.no-name.description": [
    {
      "type": 0,
      "value": "Someone on your team has requested to try features on the Confluence Premium plan."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.no-name.subject": [
    {
      "type": 0,
      "value": "Approval required: Someone in your team wants to try new features"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.no-name.title": [
    {
      "type": 0,
      "value": "Unlock more insights, clarity, and speed for your team"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.subject": [
    {
      "type": 0,
      "value": "Approval required: "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " wants to try new features"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.title": [
    {
      "type": 0,
      "value": "Unlock more insights, clarity, and speed for "
    },
    {
      "type": 1,
      "value": "firstName"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.explore-all-features": [
    {
      "type": 0,
      "value": "Explore all features →"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.get-started-button": [
    {
      "type": 0,
      "value": "Get Started"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.img.alt": [
    {
      "type": 0,
      "value": "Confluence logo"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.learn-more": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.description": [
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " wants to try advanced whiteboard features on the Premium plan. This will let them create unlimited whiteboards and use smart integrations."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.no-name.description": [
    {
      "type": 0,
      "value": "Someone on your team wants to try advanced whiteboard features on the Premium plan. This will let them create unlimited whiteboards and use smart integrations."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.no-name.subject": [
    {
      "type": 0,
      "value": "Approval required: Someone in your team wants to try advanced whiteboard features"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.no-name.title": [
    {
      "type": 0,
      "value": "Boost your team's collaboration"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.subject": [
    {
      "type": 0,
      "value": "Approval required: "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": " wants to try advanced whiteboard features"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.title": [
    {
      "type": 0,
      "value": "Boost "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": "'s team collaboration"
    }
  ],
  "growth-luna.jira-manual-trial-awareness-modal.screen-space-flags.description.no-translate": [
    {
      "type": 0,
      "value": "You have "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " day"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " days"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "trialDaysLeft"
    },
    {
      "type": 0,
      "value": " to try new features that help teams like yours get more done."
    }
  ],
  "growth-luna.jira-manual-trial-awareness-modal.screen-space-flags.title.no-translate": [
    {
      "type": 0,
      "value": "Your new Jira "
    },
    {
      "type": 1,
      "value": "edition"
    },
    {
      "type": 0,
      "value": " trial"
    }
  ],
  "growth-luna.jira-pre-dunning-confirm-plan-modal.screen-space-flags.description.no-translate": [
    {
      "type": 0,
      "value": "TWCG-2131 content will be added here."
    }
  ],
  "growth-luna.jira-pre-dunning-confirm-plan-modal.screen-space-flags.title.no-translate": [
    {
      "type": 0,
      "value": "Confirm plan modal placeholder"
    }
  ],
  "growth-luna.jira-twcg-810-upgrade-free.action.primary.pde": [
    {
      "type": 0,
      "value": "Try it free"
    }
  ],
  "growth-luna.jira-twcg-810-upgrade-free.modal.automations.body": [
    {
      "type": 0,
      "value": "Your team has already used half your free automation runs. Try a higher limit free for "
    },
    {
      "type": 1,
      "value": "trialLength"
    },
    {
      "type": 0,
      "value": " days with "
    },
    {
      "options": {
        "other": {
          "value": [
            {
              "type": 0,
              "value": "Standard"
            }
          ]
        },
        "premium": {
          "value": [
            {
              "type": 0,
              "value": "Premium"
            }
          ]
        },
        "standard": {
          "value": [
            {
              "type": 0,
              "value": "Standard"
            }
          ]
        }
      },
      "type": 5,
      "value": "edition"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "growth-luna.jira-twcg-810-upgrade-free.modal.automations.feature.limit": [
    {
      "type": 0,
      "value": "Increase your limit to 1,700 monthly runs"
    }
  ],
  "growth-luna.jira-twcg-810-upgrade-free.modal.automations.feature.rovo": [
    {
      "type": 0,
      "value": "Create new automations fast with Rovo AI"
    }
  ],
  "growth-luna.jira-twcg-810-upgrade-free.modal.automations.feature.workflows": [
    {
      "type": 0,
      "value": "Keep workflows moving and avoid interruptions"
    }
  ],
  "growth-luna.jira-twcg-810-upgrade-free.modal.automations.heading": [
    {
      "type": 0,
      "value": "Keep your "
    },
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " rules running"
    }
  ],
  "growth-luna.jira-twcg-810-upgrade-free.modal.plans.body": [
    {
      "type": 0,
      "value": "See progress across your team's work in one view. Try Plans free for "
    },
    {
      "type": 1,
      "value": "trialLength"
    },
    {
      "type": 0,
      "value": " days with "
    },
    {
      "options": {
        "other": {
          "value": [
            {
              "type": 0,
              "value": "Standard"
            }
          ]
        },
        "premium": {
          "value": [
            {
              "type": 0,
              "value": "Premium"
            }
          ]
        },
        "standard": {
          "value": [
            {
              "type": 0,
              "value": "Standard"
            }
          ]
        }
      },
      "type": 5,
      "value": "edition"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "growth-luna.jira-twcg-810-upgrade-free.modal.plans.feature.blockers": [
    {
      "type": 0,
      "value": "Spot blockers early and keep things moving"
    }
  ],
  "growth-luna.jira-twcg-810-upgrade-free.modal.plans.feature.goals": [
    {
      "type": 0,
      "value": "Help your team hit goals together"
    }
  ],
  "growth-luna.jira-twcg-810-upgrade-free.modal.plans.feature.timelines": [
    {
      "type": 0,
      "value": "Create one view of all your team's timelines"
    }
  ],
  "growth-luna.jira-twcg-810-upgrade-free.modal.plans.heading": [
    {
      "type": 0,
      "value": "Keep your "
    },
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " projects on track"
    }
  ],
  "growth-luna.jira-twcg-810-upgrade-free.modal.rovo.body": [
    {
      "type": 0,
      "value": "Help your team move work in progress faster. Try Rovo AI free for "
    },
    {
      "type": 1,
      "value": "trialLength"
    },
    {
      "type": 0,
      "value": " days with "
    },
    {
      "options": {
        "other": {
          "value": [
            {
              "type": 0,
              "value": "Standard"
            }
          ]
        },
        "premium": {
          "value": [
            {
              "type": 0,
              "value": "Premium"
            }
          ]
        },
        "standard": {
          "value": [
            {
              "type": 0,
              "value": "Standard"
            }
          ]
        }
      },
      "type": 5,
      "value": "edition"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "growth-luna.jira-twcg-810-upgrade-free.modal.rovo.feature.connect": [
    {
      "type": 0,
      "value": "Connect related and duplicate tasks automatically"
    }
  ],
  "growth-luna.jira-twcg-810-upgrade-free.modal.rovo.feature.next-steps": [
    {
      "type": 0,
      "value": "Turn big work into clearer next steps"
    }
  ],
  "growth-luna.jira-twcg-810-upgrade-free.modal.rovo.feature.summaries": [
    {
      "type": 0,
      "value": "Get instant summaries of what's happening"
    }
  ],
  "growth-luna.jira-twcg-810-upgrade-free.modal.rovo.heading": [
    {
      "offset": 0,
      "options": {
        "=0": {
          "value": [
            {
              "type": 0,
              "value": "Stay across your team's tasks"
            }
          ]
        },
        "one": {
          "value": [
            {
              "type": 0,
              "value": "Stay across your team's "
            },
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " task"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "Stay across your team's "
            },
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " tasks"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "growth-luna.jira-twcg-810-upgrade-free.placement.banner.automations.cta": [
    {
      "type": 0,
      "value": "Get more runs"
    }
  ],
  "growth-luna.jira-twcg-810-upgrade-free.placement.banner.automations.title": [
    {
      "type": 0,
      "value": "Keep your "
    },
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " rules running"
    }
  ],
  "growth-luna.jira-twcg-810-upgrade-free.placement.banner.plans.cta": [
    {
      "type": 0,
      "value": "Try Plans"
    }
  ],
  "growth-luna.jira-twcg-810-upgrade-free.placement.banner.plans.title": [
    {
      "type": 0,
      "value": "Keep your "
    },
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " projects on track"
    }
  ],
  "growth-luna.jira-twcg-810-upgrade-free.placement.banner.rovo.cta": [
    {
      "type": 0,
      "value": "Try Rovo"
    }
  ],
  "growth-luna.jira-twcg-810-upgrade-free.placement.banner.rovo.title": [
    {
      "offset": 0,
      "options": {
        "=0": {
          "value": [
            {
              "type": 0,
              "value": "Stay across your team's tasks"
            }
          ]
        },
        "one": {
          "value": [
            {
              "type": 0,
              "value": "Stay across your team's "
            },
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " task"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "Stay across your team's "
            },
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " tasks"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "post-office.ep-migration-inapp-715.body": [
    {
      "type": 0,
      "value": "Get Confluence Premium to ship projects faster with advanced admin controls and analytics."
    }
  ],
  "post-office.ep-migration-inapp-715.change-plans-button": [
    {
      "type": 0,
      "value": "Change plans"
    }
  ],
  "post-office.ep-migration-inapp-715.image-alt": [
    {
      "type": 0,
      "value": "Confluence Premium illustration"
    }
  ],
  "post-office.ep-migration-inapp-715.not-now-button": [
    {
      "type": 0,
      "value": "Not now"
    }
  ],
  "post-office.ep-migration-inapp-715.title": [
    {
      "type": 0,
      "value": "Grow more agile"
    }
  ],
  "post-office.jira-exp-banner.main-heading.no-translate": [
    {
      "type": 0,
      "value": "Welcome to Placements v2"
    }
  ],
  "post-office.jira-standard-automation-limit-awareness-banner.close": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "post-office.jira-standard-automation-limit-awareness-banner.message": [
    {
      "type": 0,
      "value": "You're nearing or at your monthly automation run limit. Automations will fail to run this month if you hit the limit."
    }
  ]
}